import autoTable from 'jspdf-autotable';
import jsPDF from 'jspdf';

export const formatDateTime = (dateTimeString) => {
  const date = new Date(dateTimeString);
  return {
    date: date.toLocaleDateString(),
    time: date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  };
};

export const getPriorityColor = (priority) => {
  if (!priority) return 'bg-gray-100 text-gray-800 border border-gray-200';
  switch (priority.toLowerCase()) {
    case 'emergency':
      return 'bg-red-100 text-red-800 border border-red-200';
    case 'urgent':
      return 'bg-orange-100 text-orange-800 border border-orange-200';
    case 'routine':
      return 'bg-blue-100 text-blue-800 border border-blue-200';
    case 'elective':
      return 'bg-green-100 text-green-800 border border-green-200';
    default:
      return 'bg-gray-100 text-gray-800 border border-gray-200';
  }
};

export const handleExportPDF = async (filteredRows) => {
  const doc = new jsPDF();
  const logoUrl = '/logo.png';
  
  const toDataURL = (url) => new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = reject;
    img.src = url;
  });

  try {
    const logoData = await toDataURL(logoUrl);
    doc.addImage(logoData, 'PNG', 14, 10, 30, 30);
  } catch (error) {
    console.error('Failed to load logo image', error);
  }

  doc.setFontSize(16);
  doc.text("OT Booking List", 50, 25);

  const tableColumn = [
    "S/No",
    "UHID No",
    "Patient Name",
    "Booking Date & Time",
    "Surgery Type",
    "Surgical Code",
    "Priority",
    "Room No",
  ];

  const tableRows = filteredRows.map((row, index) => [
    index + 1,
    row.uhid_no,
    row.patient_name,
    new Date(row.booking_datetime).toLocaleString(),
    row.type_of_surgery,
    row.surgical_code,
    row.priority_status,
    row.room_no || "N/A",
  ]);

  autoTable(doc, {
    startY: 45,
    head: [tableColumn],
    body: tableRows,
    headStyles: {
      fillColor: [0, 128, 128], // Teal color
      textColor: [255, 255, 255],
    },
    alternateRowStyles: {
      fillColor: [240, 240, 240],
    },
  });

  doc.save("OT_Bookings.pdf");
};
